 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		46: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		46: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---src-pages-404-js","5":"component---src-pages-index-mdx","6":"component---src-pages-instructor-guide-00-what-is-egghead-mdx","7":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-01-why-be-an-instructor-mdx","8":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-02-joining-slack-mdx","9":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-03-meeting-your-coach-mdx","10":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-04-create-your-30-second-lesson-mdx","11":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-05-getting-feedback-on-your-video-mdx","12":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-06-receiving-your-equipment-mdx","13":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-07-getting-paid-mdx","14":"component---src-pages-instructor-guide-02-creating-lessons-01-what-makes-a-great-lesson-mdx","15":"component---src-pages-instructor-guide-02-creating-lessons-02-what-should-you-teach-mdx","16":"component---src-pages-instructor-guide-02-creating-lessons-03-what-if-a-lesson-already-exists-mdx","17":"component---src-pages-instructor-guide-02-creating-lessons-04-write-the-title-and-summary-mdx","18":"component---src-pages-instructor-guide-02-creating-lessons-05-create-your-code-example-mdx","19":"component---src-pages-instructor-guide-02-creating-lessons-06-how-to-instruct-mdx","20":"component---src-pages-instructor-guide-02-creating-lessons-07-speak-concisely-mdx","21":"component---src-pages-instructor-guide-02-creating-lessons-08-the-show-your-work-trick-mdx","22":"component---src-pages-instructor-guide-02-creating-lessons-09-record-and-upload-your-lesson-mdx","23":"component---src-pages-instructor-guide-02-creating-lessons-10-when-well-publish-your-lesson-mdx","24":"component---src-pages-instructor-guide-03-creating-courses-01-why-create-a-course-mdx","25":"component---src-pages-instructor-guide-03-creating-courses-02-how-to-structure-your-course-mdx","26":"component---src-pages-instructor-guide-03-creating-courses-03-write-your-course-proposal-mdx","27":"component---src-pages-instructor-guide-03-creating-courses-04-your-course-code-example-mdx","28":"component---src-pages-instructor-guide-03-creating-courses-05-record-your-course-mdx","29":"component---src-pages-instructor-guide-03-creating-courses-06-create-your-course-overview-mdx","30":"component---src-pages-instructor-guide-03-creating-courses-07-maintain-your-course-mdx","31":"component---src-pages-instructor-guide-04-screencasting-tips-01-prepare-your-screen-for-recording-mdx","32":"component---src-pages-instructor-guide-04-screencasting-tips-02-set-up-your-audio-mdx","33":"component---src-pages-instructor-guide-04-screencasting-tips-03-record-your-lesson-mdx","34":"component---src-pages-instructor-guide-04-screencasting-tips-04-edit-your-lesson-mdx","35":"component---src-pages-instructor-guide-04-screencasting-tips-05-sharing-your-code-mdx","36":"component---src-pages-instructor-guide-04-screencasting-tips-06-host-a-demo-rest-api-mdx","37":"component---src-pages-instructor-guide-05-odds-and-ends-01-egghead-on-slack-mdx","38":"component---src-pages-instructor-guide-05-odds-and-ends-02-our-contributor-agreement-mdx","39":"component---src-pages-review-js","40":"component---src-pages-reviewer-guide-01-review-00-review-101-mdx","41":"component---src-pages-reviewer-guide-01-review-01-identify-changes-in-framework-mdx","42":"component---src-pages-reviewer-guide-01-review-02-title-lessons-mdx","43":"component---src-pages-reviewer-guide-01-review-03-review-template-mdx","44":"component---src-templates-chapter-js","45":"pages-manifest"}[chunkId]||chunkId) + "-" + {"0":"bc637403d6b37d70953d","1":"9e1d93a953e82b01ba37","2":"bcf2571dd8fcea6c5a51","4":"53a6fc2d964366dbdec2","5":"2211c9b5a7b2a92588c1","6":"ddb596c2a987ff2ab185","7":"265a22c12334279a5b1d","8":"b190f26d2387d0621487","9":"06d25fda74a55ae1dbd6","10":"aa31e89ed2f5eca98204","11":"12088899dd4aa7571d59","12":"fb086058a7c64810884e","13":"d00b488e106d8b39daae","14":"d90b903cb2409bd836f6","15":"22b7aa4bffdc910a4183","16":"3f29a261a06882cb34d1","17":"d1bc407c56fefe4390a6","18":"6346da7b32f3aeeed380","19":"e62b3f0fbc393b70b54e","20":"c841912a406f8f0eaee8","21":"37f58106a298309e2597","22":"1b7f27d2eeefd22ab927","23":"58f1c6f2411d5b6a8afc","24":"b625a80773c9d2ecdd04","25":"45d0b622bf662faa337b","26":"ec6704169caea7e666a5","27":"0a760c89649d9f1c8a80","28":"248a8c511960146cb3a5","29":"eb9b4ce4b1460b8ffda5","30":"9191710ad5a437b6f317","31":"741f8a6780ccd12c54c9","32":"efe68ffcda134f293a22","33":"750f6c84f65bf61fb933","34":"dc76cdfdbf1a82f5d1ed","35":"6b6f2d0a75144952a786","36":"53e5409b6cb6ee81c351","37":"219ac510e85cb6eef05a","38":"885f77eeaf45d4ec19c7","39":"6a4288dcc545be00f774","40":"b493686da532093ff4bf","41":"511765a3b48404fbb928","42":"f5993f283e83f13f549f","43":"f389155a97bdf10a65e6","44":"6c23ad9fa60959390475","45":"9c2b88175ae38953678c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"4":"component---src-pages-404-js","5":"component---src-pages-index-mdx","6":"component---src-pages-instructor-guide-00-what-is-egghead-mdx","7":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-01-why-be-an-instructor-mdx","8":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-02-joining-slack-mdx","9":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-03-meeting-your-coach-mdx","10":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-04-create-your-30-second-lesson-mdx","11":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-05-getting-feedback-on-your-video-mdx","12":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-06-receiving-your-equipment-mdx","13":"component---src-pages-instructor-guide-01-getting-started-as-an-egghead-instructor-07-getting-paid-mdx","14":"component---src-pages-instructor-guide-02-creating-lessons-01-what-makes-a-great-lesson-mdx","15":"component---src-pages-instructor-guide-02-creating-lessons-02-what-should-you-teach-mdx","16":"component---src-pages-instructor-guide-02-creating-lessons-03-what-if-a-lesson-already-exists-mdx","17":"component---src-pages-instructor-guide-02-creating-lessons-04-write-the-title-and-summary-mdx","18":"component---src-pages-instructor-guide-02-creating-lessons-05-create-your-code-example-mdx","19":"component---src-pages-instructor-guide-02-creating-lessons-06-how-to-instruct-mdx","20":"component---src-pages-instructor-guide-02-creating-lessons-07-speak-concisely-mdx","21":"component---src-pages-instructor-guide-02-creating-lessons-08-the-show-your-work-trick-mdx","22":"component---src-pages-instructor-guide-02-creating-lessons-09-record-and-upload-your-lesson-mdx","23":"component---src-pages-instructor-guide-02-creating-lessons-10-when-well-publish-your-lesson-mdx","24":"component---src-pages-instructor-guide-03-creating-courses-01-why-create-a-course-mdx","25":"component---src-pages-instructor-guide-03-creating-courses-02-how-to-structure-your-course-mdx","26":"component---src-pages-instructor-guide-03-creating-courses-03-write-your-course-proposal-mdx","27":"component---src-pages-instructor-guide-03-creating-courses-04-your-course-code-example-mdx","28":"component---src-pages-instructor-guide-03-creating-courses-05-record-your-course-mdx","29":"component---src-pages-instructor-guide-03-creating-courses-06-create-your-course-overview-mdx","30":"component---src-pages-instructor-guide-03-creating-courses-07-maintain-your-course-mdx","31":"component---src-pages-instructor-guide-04-screencasting-tips-01-prepare-your-screen-for-recording-mdx","32":"component---src-pages-instructor-guide-04-screencasting-tips-02-set-up-your-audio-mdx","33":"component---src-pages-instructor-guide-04-screencasting-tips-03-record-your-lesson-mdx","34":"component---src-pages-instructor-guide-04-screencasting-tips-04-edit-your-lesson-mdx","35":"component---src-pages-instructor-guide-04-screencasting-tips-05-sharing-your-code-mdx","36":"component---src-pages-instructor-guide-04-screencasting-tips-06-host-a-demo-rest-api-mdx","37":"component---src-pages-instructor-guide-05-odds-and-ends-01-egghead-on-slack-mdx","38":"component---src-pages-instructor-guide-05-odds-and-ends-02-our-contributor-agreement-mdx","39":"component---src-pages-review-js","40":"component---src-pages-reviewer-guide-01-review-00-review-101-mdx","41":"component---src-pages-reviewer-guide-01-review-01-identify-changes-in-framework-mdx","42":"component---src-pages-reviewer-guide-01-review-02-title-lessons-mdx","43":"component---src-pages-reviewer-guide-01-review-03-review-template-mdx","44":"component---src-templates-chapter-js","45":"pages-manifest"}[chunkId]||chunkId) + "." + {"0":"a82bc48cfa31deea5b5f","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
